import React from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const VendorListQues = ({
  isLoadingSelect,
  dropDownVendorData,
  assignVendorList,
  handleChange,
}) => {
  const filteredDropDownVendorList = dropDownVendorData.filter((vendor) => {
    const hasAssignedQuestionnaire = vendor?.questionnaire.some(
      (questionnaire) => {
        return (
          questionnaire?.questionnaireId.id === assignVendorList?.quesId &&
          (questionnaire?.status === "assigned" ||
            questionnaire?.status === "reAssigned" ||
            questionnaire?.status === "submitted" ||
            questionnaire?.status === "reSubmitted")
        );
      }
    );
    return !hasAssignedQuestionnaire;
  });

  return (
    <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      isLoading={isLoadingSelect}
      onChange={handleChange}
      options={filteredDropDownVendorList}
      getOptionLabel={(option) => option?.vendorLegalName}
      getOptionValue={(option) => option?.id}
      className="focus:!border-black focus:!border-2 focus:!border-t-0"
    />
  );
};

export default VendorListQues;
